import { render, staticRenderFns } from "./PCGame.vue?vue&type=template&id=8326804a&scoped=true"
import script from "./PCGame.vue?vue&type=script&lang=js"
export * from "./PCGame.vue?vue&type=script&lang=js"
import style0 from "./PCGame.vue?vue&type=style&index=0&id=8326804a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8326804a",
  null
  
)

export default component.exports